import React, {Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux";
import Maps from '../components/Maps'
import Table from "./Table";
import {HotKeys} from "react-hotkeys";
import changes from "../redux/changesDuck"
import {useFirestore} from "react-redux-firebase";
import {activeChangeSelector} from "../redux/changesSelectors";
import { withStyles } from '@material-ui/core/styles';
import Card from "@material-ui/core/Card";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";


const keyMap = {swap: {sequence: 's'},
                good: {sequence: 'g'},
                bad: {sequence: 'b'},
    action:'keyup',
   }


function createMenuItem(menuObj){
    return <MenuItem value={menuObj.index} key={menuObj.index}>{menuObj.name}</MenuItem>
}

const styles = {
  cradle: {
      position: 'absolute',
    border: 0,
    borderRadius: 3,

    color: 'white',
      width: '25%',

    padding: '0 30px',
      zIndex: 2
  },
};


function MapsContainer(props){
    const {classes} = props
    const mapProps = useSelector(
        state => state.map)

    const availableLayers = useSelector((state)=>state.changes.layers.map((o, i)=>{
        return {name: o.id, index: i}}))
    const {selectedValue, activeLayerId, changeType, selected} = useSelector(activeChangeSelector)
    const dispatch = useDispatch();
    const firestore = useFirestore();

    const  toggleVisibility = () => {
        dispatch(changes.actions.toggleLayer({}))}

      const handlers = {
      swap: toggleVisibility,
        good: () => {if (!selectedValue){return}
                return firestore.set([activeLayerId, changeType, 'qa', selectedValue].join('/'), {status: 'Good'})},
                bad: () => {if (!selectedValue){return}
                return firestore.set([activeLayerId, changeType, 'qa', selectedValue].join('/'), {status: 'Bad'})}

    };
    const handleChange = (e)=> {
        dispatch(changes.actions.setChanges(e.target.value))
        dispatch(changes.actions.fetchChangesRequest({}))}
    return (
   <HotKeys keyMap={keyMap} handlers={handlers} allowChanges={true}>
        <Fragment>
            <Card className={classes.cradle}>

                <Select id="layer-picker" value={selected}
          onChange={handleChange}>
                    {createMenuItem({name:'', value: -1})}
         {availableLayers.map(createMenuItem)}
        </Select>
                { loadTable(selected)}
            </Card>
        <Maps {...mapProps}/>
        </Fragment>
   </HotKeys>
    )}

function loadTable(selected){
    if (selected===-1){return null}
    return <Table/>
}



export default withStyles(styles)(MapsContainer)



// WEBPACK FOOTER //
// ./src/containers/Maps.js